export interface FooterAriaModel {
  primaryButton?: string;
  secondaryButton?: string;
  tip?: string;
}
